import React, {memo, useState, useEffect} from "../../../../__snowpack__/pkg/react.js";
import {Modal, Progress, Button} from "../../../../__snowpack__/pkg/antd.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import {urlSplitList, batchDownloadOperation} from "../../order/lib/batchDownloadOperation.js";
import {axios} from "../../../lib/axios.js";
import GnAlert from "../../../components/GnAlert/index.js";
export const ExportResultsModal = memo((props) => {
  const {ExportResultsVisible, TaskId, handelCancel} = props;
  const {formatMessage} = useIntl();
  const [PercentCount, setPercentCount] = useState(0);
  const [ResultsInfo, setResultsInfo] = useState();
  const [DownLoadUrlList, setDownLoadUrlList] = useState([]);
  const [OperationStatus, setOperationStatus] = useState("IN_PROCESS");
  useEffect(() => {
    getProgressResults();
    ActualTimeApi();
    return () => {
      clearInterval(window.timer);
    };
  }, []);
  const ActualTimeApi = () => {
    window.timer = setInterval(() => {
      if (PercentCount === 100 || ["FINISHED", "FAILED"].includes(OperationStatus)) {
        clearInterval(window.timer);
      } else {
        getProgressResults();
      }
    }, 1e3);
  };
  const getProgressResults = async () => {
    try {
      const formData = new FormData();
      formData.append("taskId", TaskId);
      const {data} = await axios.post("/saas/file-warehouse/get/export-data", formData);
      if (data?.downloadUrl) {
        let urlList = urlSplitList(data?.downloadUrl || "");
        setDownLoadUrlList(urlList);
      }
      setResultsInfo(data);
      setPercentCount(data.rateOfProcess);
      setOperationStatus(data.status);
      if (data.status === "FINISHED") {
        clearInterval(window.timer);
      } else {
        if (data.status === "FAILED") {
          clearInterval(window.timer);
        }
      }
    } catch (error) {
      setOperationStatus("FAILED");
    }
  };
  const handelConfirm = () => {
    switch (OperationStatus) {
      case "FINISHED":
        batchDownloadOperation(DownLoadUrlList, handelCancel);
        break;
      case "FAILED":
        handelCancel();
    }
  };
  return /* @__PURE__ */ React.createElement(Modal, {
    title: formatMessage({id: "ExportResultTitle"}),
    visible: ExportResultsVisible,
    maskClosable: false,
    width: 600,
    onCancel: () => handelCancel(),
    footer: /* @__PURE__ */ React.createElement(Button, {
      type: "primary",
      onClick: () => handelConfirm(),
      disabled: !["FINISHED", "FAILED"].includes(OperationStatus)
    }, formatMessage({
      id: OperationStatus === "FINISHED" ? "ExportDownload" : "Confirm"
    }))
  }, /* @__PURE__ */ React.createElement(GnAlert, {
    message: formatMessage({
      id: OperationStatus === "FINISHED" ? "ExportFileGenerated" : ["IN_PROCESS", "CREATED", "PENDING"].includes(OperationStatus) ? "ExportFileInProcess" : "ExportFileFailed"
    }),
    type: OperationStatus === "FINISHED" ? "success" : ["IN_PROCESS", "CREATED", "PENDING"].includes(OperationStatus) ? "info" : "error",
    showIcon: true,
    style: {marginBottom: 16}
  }), /* @__PURE__ */ React.createElement(Progress, {
    strokeColor: {from: "#B699FF", to: "#4C04FF"},
    percent: PercentCount,
    strokeWidth: 20,
    status: "active"
  }), OperationStatus === "FINISHED" && /* @__PURE__ */ React.createElement("div", {
    style: {marginTop: 16}
  }, formatMessage({id: "FileSaveHistoryDays"})), OperationStatus === "FAILED" && /* @__PURE__ */ React.createElement("div", {
    style: {marginTop: 16}
  }, /* @__PURE__ */ React.createElement("span", {
    style: {color: "rgba(0, 0, 0, 0.85)"}
  }, formatMessage({id: "ExportFiledReason"})), ResultsInfo?.failMessage));
});
